import React from 'react';

import css from './style.module.scss';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';
import Button from '../../Controls/Button';

interface IProps {
  icon: string;
  title: string;
  description: string;
  action?: {
    text: string;
    onClick: () => void;
  };
}

const Error = ({ icon, title, description, action }: IProps) => {
  return (
    <div className={css.error}>
      <div className={css.error__image}>
        <Icon id={icon} />
      </div>
      <div className={css.error__title}>{title}</div>
      <div className={css.error__description}>{description}</div>
      {action && <Button padding="0-26" width="auto" onClick={action.onClick} text={action.text} />}
    </div>
  );
};

export default Error;
